export interface UpdateAnnotationDto {
    content: string;
    taskName: string;
    workflowArea?: string;
    mentions?: string[];
}
